import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface CurrencyEuroRatesResponse {
  base: string;
  rates: { [key: string]: number };
}

export type GetCurrencyEuroRatesCall = () => Promise<{
  data: CurrencyEuroRatesResponse;
}>;

export default (makeCall: MakeCall) => () =>
  makeCall<CurrencyEuroRatesResponse>('GET', `/api/v2/currency/EUR/rates`);
